<!-- <template>
	<div class="Com_8">
	  <title1 type="1" title="场站利用率热榜">
	  </title1>
	  <div class="Com_8_bottom" style="width: 440; height: 384px">
		<div class="row-box" v-for="(item, index) in list" :key="index">
		  <div style=" display: flex;">
			<div :style="`--f:${item.Namecolor}`" class="name">
			  <span class="sortName">{{ item.name }}</span
			  >&nbsp;
			</div>
		  </div>
		  <div style="width: 100%; display: flex;">
			<div
			  class="row"
			  :style="`--l:${item.line};--w:${item.number + '%'};`"
			></div>
		  </div>
		  <div :style="{ color: item.Namecolor }" class="number">{{item.number}}%</div>
		</div>
	  </div>
	</div>
  </template>
	
	<script>
  import title1 from "@/views/exposition/components/title4";
  import { dataInterface } from "@/api/dataInterfaceApi";
  export default {
	components: {
	  title1,
	},
	data() {
	  return {
		showcdata: false,
		list: [
		  {
			name: "NO.1",
			number: 98,
			station_name: "甘肃一号站",
			Namecolor: "rgba(214, 153, 119, 1)",
			line: "linear-gradient(270deg, #D69977 0%, rgba(214,153,119,0) 100%)",
		  },
		  {
			name: "NO.2",
			number: 88,
			station_name: "甘肃一号站",
			Namecolor: "rgba(243, 214, 142, 1)",
			line: "linear-gradient(270deg, #F3D68E 0%, rgba(243,214,142,0) 100%)",
		  },
		  {
			name: "NO.3",
			number: 85,
			station_name: "甘肃一号站",
			Namecolor: "rgba(152, 226, 159, 1)",
			line: "linear-gradient(270deg, #88D9BE 0%, rgba(136,217,190,0) 100%)",
		  },
		  {
			name: "",
			number: 80,
			station_name: "甘肃一号站",
			Namecolor: "skyblue",
			line: "rgba(255, 255, 255, 0.05)",
		  },
		  {
			name: "",
			number: 70,
			station_name: "甘肃一号站",
			Namecolor: "skyblue",
			line: "rgba(255, 255, 255, 0.05)",
		  },
		  {
			name: "",
			number: 60,
			station_name: "甘肃一号站",
			Namecolor: "rgba(243, 214, 142, 1)",
			line: "rgba(255, 255, 255, 0.05)",
		  },
		  {
			name: "",
			number: 50,
			station_name: "甘肃一号站",
			Namecolor: "rgba(152, 226, 159, 1)",
			line: "rgba(255, 255, 255, 0.05)",
		  },
		  {
			name: "",
			number: 40,
			station_name: "甘肃一号站",
			Namecolor: "skyblue",
			line: "rgba(255, 255, 255, 0.05)",
		  },
		  {
			name: "",
			number: 40,
			station_name: "甘肃一号站",
			Namecolor: "skyblue",
			line: "rgba(255, 255, 255, 0.05)",
		  }
		],
		query: this.$route.query
	  };
	},
	mounted() {
	  this.$bus.$on("onfangdiangonglv", () => {
		this.getBattery24hours();
	  });
	  this.getBattery24hours();
	},
	destroyed() {
	  // this.$bus.$off('onfangdiangonglv')
	},
	methods: {
	  //获取24小时电次数分布
	  getBattery24hours() {
		let cityCode =  this.query.province || this.query.city || '000000'
		let params = {
		  enCode: "zngf-qg-gzdljfdlpmtop10", // 接口code
		  // 接口传参
		  "@adcode": cityCode,
		};
		this.showcdata = false;
		dataInterface
		  .dataFaceApi(params)
		  .then((res) => {
			console.log(res, "累计发电热量榜");
			if (res) {
			  let data = res || [];
			  // this.list[0].station_name = data[0].station_name
			  // this.list[0].number = Math.ceil((Number(data[0].power_generation_capacity) / (3 * 100000000)) * 100)
			  console.log(data, "sjsjsjss");
			  this.showcdata = true;
			  let merged = [];
  
			//   this.list.forEach((item1, index1) => {
			// 	let item2 = data[index1];
  
			// 	if (item2) {
			// 	  // 下标相同，直接合并
			// 	  merged.push({
			// 		...item1,
			// 		...item2,
			// 	  });
			// 	} else {

			// 	}
			//   });
  

			
			//   let arr = merged.map((item,index) =>{
			// 	return {
			// 	  ...item,
			// 	  number:Math.ceil((Number(item.power_generation_capacity) / (1 * 15000)) * 100)
			// 	}
			//   })
			  console.log(arr,'mergedmergedmergedmerged')
			  this.list = arr || []
			}
		  })
		  .catch((err) => {
			console.log(err);
		  });
	  },
	},
  };
  </script>
	
  <style lang="scss" scoped>
    @import "@/assets/scss/comm.scss";
  $--l: white;
  $--f: white;
  $--w: 0;
  .Com_8 {
	.Com_8_bottom {
	  // background: red;
	  .row-box {
		width: 100%;
		height: 35px;
		margin: 0px 0;
		display: flex;
		// flex-direction: column;
		.name {
		  font-size: 18px;
		  @include ffamily-HT;
		  .sortName {
			width: 50px;
			color: var(--f);
			display: inline-block;
		  }
		}
		.Numbername {
		  font-size: 20px;
		}
		.row {
		  display: flex;
		  // align-items: center;
		  width: 90%;
		  height: 8px;
		  background: rgba(255, 255, 255, 0.05);
		  // background: red;
		  margin: 10px 0;
		  border-radius: 20px;
		  position: relative;
		}
		.row::after {
		  content: "";
		  position: absolute;
		  top: 2px;
		  left: 0;
		  height: 4px;
		  width: var(--w);
		  background: var(--l);
		  z-index: 2;
		  border-radius: 20px;
		  transition: width 1s linear;
		}
		.number{
			@include ffamily-DS;
		}
	  }
	}
  }
  </style> -->


  <template>
	<div class="Com_8">
	  <title1 type="2" title="场站利用率热榜">
	  </title1>
	  <div class="Com_8_bottom" style="width: 440px; height: 384px">
		<div class="row-box" v-for="(item, index) in list" :key="index">
		  <div style="width: 100%; display: flex; justify-content: space-between">
			<div :style="`--f:${item.Namecolor}`" class="name">
			  <span class="sortName">{{ item.name }}</span
			  >&nbsp;<span class="station_name">{{ item.station_name }}</span>
			</div>
			<div class="Numbername" :style="{ color: item.Namecolor }">
			  {{ item.number }}%
			</div>
		  </div>
		  <div style="width: 100%; display: flex; justify-content: flex-end">
			<div
			  class="row"
			  :style="`--l:${item.line};--w:${item.number + '%'};`"
			></div>
		  </div>
		</div>
	  </div>
	</div>
  </template>
	
	<script>
  import title1 from "@/views/exposition/components/title3";
  import { dataInterface } from "@/api/dataInterfaceApi";
  export default {
	components: {
	  title1,
	},
	data() {
	  return {
		showcdata: false,
		list: [
		  {
			name: "NO.1",
			number: 83.52,
			station_name: "腾达琅阁超级充电站",
			Namecolor: "rgba(214, 153, 119, 1)",
			line: "linear-gradient(270deg, #D69977 0%, rgba(214,153,119,0) 100%)",
		  },
		  {
			name: "NO.2",
			number: 79.83,
			station_name: "永平充电站",
			Namecolor: "rgba(243, 214, 142, 1)",
			line: "linear-gradient(270deg, #F3D68E 0%, rgba(243,214,142,0) 100%)",
		  },
		  {
			name: "NO.3",
			number: 73.23,
			station_name: "罗冲围充电站",
			Namecolor: "rgba(152, 226, 159, 1)",
			line: "linear-gradient(270deg, #88D9BE 0%, rgba(136,217,190,0) 100%)",
		  },
		  {
			name: "",
			number: 69.35,
			station_name: "云城花湖超级充电站",
			Namecolor: "skyblue",
			line: "linear-gradient(270deg, #80C7FA 0%, rgba(128,199,250,0) 100%)",
		  },
		  {
			name: "",
			number: 59.85,
			station_name: "富力桃园公交站场充电站",
			Namecolor: "skyblue",
			line: "linear-gradient(270deg, #80C7FA 0%, rgba(128,199,250,0) 100%)",
		  },
		],
		query: this.$route.query
	  };
	},
	mounted() {
	  this.$bus.$on("onfangdiangonglv", () => {
		this.getBattery24hours();
	  });
	  this.getBattery24hours();
	},
	destroyed() {
	  // this.$bus.$off('onfangdiangonglv')
	},
	methods: {
	  //获取24小时电次数分布
	  getBattery24hours() {
		let cityCode =  this.query.province || this.query.city || '000000'
		let params = {
		  enCode: "zngf-qg-gzdljfdlpmtop10", // 接口code
		  // 接口传参
		  "@adcode": cityCode,
		};
		this.showcdata = false;
		dataInterface
		  .dataFaceApi(params)
		  .then((res) => {
			console.log(res, "累计发电热量榜");
			if (res) {
			  let data = res || [];
			
			  console.log(data, "sjsjsjss");
			  this.showcdata = true;
			  let merged = [];
  
			//   this.list.forEach((item1, index1) => {
			// 	let item2 = data[index1];
  
			// 	if (item2) {
			// 	  // 下标相同，直接合并
			// 	  merged.push({
			// 		...item1,
			// 		...item2,
			// 	  });
			// 	} else {
			// 	}
			//   });
  
			
			//   let arr = merged.map((item,index) =>{
			// 	return {
			// 	  ...item,
			// 	  number:Math.ceil((Number(item.power_generation_capacity) / (1 * 15000)) * 100)
			// 	}
			//   })
			//   console.log(arr,'mergedmergedmergedmerged')
			//   this.list = arr || []
			}
		  })
		  .catch((err) => {
			console.log(err);
		  });
	  },
	},
  };
  </script>
	
  <style lang="scss" scoped>
@import "@/assets/scss/comm.scss";
  $--l: white;
  $--f: white;
  $--w: 0;
  .Com_8 {
	.Com_8_bottom {
	  // background: red;
	  .row-box {
		width: 100%;
		height: 40px;
		margin: 14px 0;
		display: flex;
		flex-direction: column;
		.name {
		  font-size: 18px;
		  .sortName {
			width: 50px;
			color: var(--f);
			display: inline-block;
		  }
		}
		.Numbername {
		  font-size: 20px;
		  @include ffamily-DS;
		}
		.row {
		  display: flex;
		  // align-items: center;
		  width: 90%;
		  height: 8px;
		  background: rgba(255, 255, 255, 0.05);
		  // background: red;
		  margin: 2px 0;
		  border-radius: 20px;
		  position: relative;
		}
		.row::after {
		  content: "";
		  position: absolute;
		  top: 2px;
		  left: 0;
		  height: 4px;
		  width: var(--w);
		  background: var(--l);
		  z-index: 2;
		  border-radius: 20px;
		  transition: width 1s linear;
		}
	  }
	}
  }
  </style>